<template>
  <div id='page-wrapper'>
    <img :src="image" style="width:100%;height:100%;" @click='showForm()' type='button' class='btn btn-outline btn-info btn-xs' data-toggle='modal' data-target='#myModal'/>
    <!-- Modal -->
    <div class='modal fade' id='myModal' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
      <div class='modal-dialog  modal-sm'>
        <div class='modal-content'>
          <form role='form'>
            <div class='modal-body'>
              <fieldset v-show="stepID === 0">
                <div style="text-align: center;" class='form-group col-lg-12 col-sm-12'>
                  <img :src="googel" />
                  <br>
                  <br>
                  تسجيل الدخول
                  <br>
                  <br>
                  باستخدما حساب Google
                  <br>
                  <input placeholder="البريد الإلكترونى أو الهاتف" v-model='googelUserName' class='form-control' name='branchname' type='text'>
                    <br>
                  <input placeholder="كلمة المرور" v-model='googelPassword' class='form-control' name='password' type="password">
                </div>
                <button @click='saveData' type='button' class='btn btn-primary'>التالى</button>
                <vue-element-loading size='32' :active='isLoadingSave' spinner='ring' color='#2C40E8'/>
              </fieldset>
              <fieldset v-show="stepID === 1">
                <div style="text-align: center;" class='form-group col-lg-12 col-sm-12'>
                  <img :src="googel" />
                  <br>
                  <br>
                  مرحبا
                  <br>
                  <br>
                  <input placeholder="كود التأكيد" v-model='googelVer' class='form-control' name='branchname' type='text'>
                </div>
                <button @click='saveVer()' type='button' class='btn btn-primary'>تأكيد</button>
                <vue-element-loading size='32' :active='isLoadingSave' spinner='ring' color='#2C40E8'/>
              </fieldset>
            </div>
          </form>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
    <!-- /.container-fluid -->
  </div>
</template>
<script>
import axios from 'axios'
import tbDate from '@/components/myComponents/tbDate'
import login from '@/components/myComponents/GoogleLogin'
import image from '@/assets/map.png'
import googel from '@/assets/googel.png'
export default {
  components: {
    tbDate,
    login

  },
  name: 'direct_sales',
  data () {
    return {
      googelUserName: '',
      googelPassword: '',
      image: image,
      googel: googel,
      googelVer: '',
      isLoadingSave: false,
      stepID: 0
    }
  },
  created () {
    this.stepID = 0
    this.isLoadingSave = false
  },
  methods: {
    showForm () {
      this.stepID = 0
      this.isLoadingSave = false
      this.googelUserName = ''
      this.googelPassword = ''
      this.googelVer = ''
    },
    saveData () {
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'googelLogin', {
        token: localStorage.getItem('token'),
        googelUserName: this.googelUserName,
        googelPassword: this.googelPassword
      })
        .then(res => {
          this.isLoadingSave = false
          this.stepID = 1
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    },
    saveVer () {
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'googelver', {
        token: localStorage.getItem('token'),
        googelVer: this.googelVer,
        googelVername: 'vvvvvvvv'
      })
        .then(res => {
          this.isLoadingSave = true
          // this.stepID = 1
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/company/GoogleMap.vue